import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";

import { useMutationWithError } from "@/hooks";
import { api } from "@/lib/api";
import { type User } from "@/types";

export const me = createQueryKeys("me");

const include = "position";

export const fetchMeQueryOptions = () =>
  queryOptions({
    queryKey: me._def,
    queryFn: () =>
      api
        .get<User<true, true>>(`me?include=${include}`, {
          validateStatus: (status) => status >= 200 && status < 500,
        })
        .then((response) => (response.status === 200 ? response.data : null)),
  });

export const useFetchMe = () => {
  return useQuery(fetchMeQueryOptions());
};

export interface MeRequest {
  locale?: string;
  timezone?: string;
}

export const useUpdatePreferences = () => {
  const queryClient = useQueryClient();
  return useMutationWithError({
    mutationFn: (data: MeRequest) => api.patch(`me?include=${include}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: me._def,
      });
    },
  });
};

export interface ChangePasswordRequest {
  current_password: string;
  password: string;
}

export const useChangePassword = () => {
  const queryClient = useQueryClient();
  return useMutationWithError({
    mutationFn: (data: ChangePasswordRequest) => api.put(`me/password`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: me._def,
      });
    },
  });
};
